import React, { useCallback, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faCheckDouble, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import api from "../../services/api";
import "./FluxopayNotificationCenter.css";

const formatDate = value => value ? new Intl.DateTimeFormat("pt-BR", { dateStyle: "short", timeStyle: "short" }).format(new Date(value)) : "";

export default function FluxopayNotificationCenter() {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/api/fluxopay/notifications", { params: { per_page: 30 } });
      setItems(data?.items?.data || []);
      setUnread(data?.unread_count || 0);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); const timer = setInterval(load, 60000); return () => clearInterval(timer); }, [load]);

  const markRead = async item => {
    if (!item.is_read) await api.post(`/api/fluxopay/notifications/${item.uuid}/read`);
    setItems(current => current.map(entry => entry.uuid === item.uuid ? { ...entry, is_read: true } : entry));
    setUnread(current => Math.max(0, current - (item.is_read ? 0 : 1)));
    if (item.action_url) window.location.href = item.action_url;
  };

  const markAll = async () => {
    await api.post("/api/fluxopay/notifications/read-all");
    setItems(current => current.map(item => ({ ...item, is_read: true })));
    setUnread(0);
  };

  return <div className="fxpay-notifications">
    <button type="button" className="fxpay-notifications__trigger" onClick={() => setOpen(value => !value)} aria-label="Notificações do Fluxopay">
      <FontAwesomeIcon icon={faBell} />{unread > 0 && <span>{unread > 99 ? "99+" : unread}</span>}
    </button>
    {open && <section className="fxpay-notifications__panel">
      <header><div><small>CENTRAL FLUXOPAY</small><h3>Notificações</h3></div>{unread > 0 && <button type="button" onClick={markAll}><FontAwesomeIcon icon={faCheckDouble} /> Marcar todas como lidas</button>}</header>
      <div className="fxpay-notifications__list">
        {loading && items.length === 0 ? <p>Carregando...</p> : items.length === 0 ? <p>Nenhuma notificação financeira.</p> : items.map(item => <button type="button" key={item.uuid} className={`fxpay-notifications__item severity-${item.severity} ${item.is_read ? "is-read" : ""}`} onClick={() => markRead(item)}>
          <span className="fxpay-notifications__dot"/><div><b>{item.title}</b><p>{item.message}</p><small>{formatDate(item.occurred_at)}</small></div><FontAwesomeIcon icon={faChevronRight}/>
        </button>)}
      </div>
    </section>}
  </div>;
}
